import styled, { css } from 'styled-components';
import { readableColor } from 'polished';
import { fontTitle, fontBody } from 'Styles/fonts';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import breakpoint from 'Styles/breakpoints';
import Layout from '../Layout/Layout';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import { Overflow } from '../CTABlock/CTABlock.styled';
import CTABlockOriginal from '../CTABlock/CTABlock.pim';
import Gif from '../Gif/Gif';

export const HeaderBlock = styled(Layout)`
  ${breakpoint('small')} {
    row-gap: 0px;
  }

  ${breakpoint('medium')} {
    row-gap: 0px;
  }

  ${({ $hasImages }) =>
    $hasImages ? 'position: absolute; left: 0; right: 0;' : ''};

  ${({ $verticalAlignment, $hasImages }) => {
    if (!$hasImages) return 'align-items: center;';

    switch ($verticalAlignment) {
      case 'TOP':
        return 'top: 0;';
      case 'BOTTOM':
        return 'bottom: 0;';
      default:
        return css`
          top: 0;
          bottom: 0;
          ${breakpoint('large')} {
            align-items: center;
          }
        `;
    }
  }};

  ${({ $backgroundColor, $hasImages }) => {
    if ($backgroundColor && !$hasImages) {
      return `
        background-color: ${$backgroundColor};
      `;
    }
  }};
  ${({ $layout }) => {
    if ($layout === 'COMPRESSED') {
      return 'padding: 32px 0; row-gap: 16px;';
    }

    return css`
      padding: 48px 0;

      ${breakpoint('medium')} {
        padding: 96px 0;
      }
    `;
  }};

  ${Overflow} {
    margin-top: 0;
  }
`;

export const BackgroundImageBlock = styled.div`
  width: 100%;
  grid-column: span 12;
`;

export const DesktopImage = styled(ResponsiveImage)`
  width: 100%;
  display: none;

  ${breakpoint('large')} {
    display: block;
  }
`;

export const DesktopGif = styled(Gif)`
  width: 100%;
  display: none;

  ${breakpoint('large')} {
    display: block;
  }
`;

export const MobileImage = styled(ResponsiveImage)`
  width: 100%;
  display: block;

  ${breakpoint('large')} {
    display: none;
  }
`;

export const MobileGif = styled(Gif)`
  width: 100%;
  display: block;

  ${breakpoint('large')} {
    display: none;
  }
`;

export const Editorial = styled.div`
  grid-column: 2 / 12;

  ${breakpoint('large')} {
    grid-column: 3 / 11;
  }

  ${({ $verticalAlignment }) =>
    $verticalAlignment === 'CENTER'
      ? css`
          align-self: flex-end;
          ${breakpoint('large')} {
            align-self: unset;
          }
        `
      : ''}

  ${({ $backgroundColor, $hasImages, $textColor }) => {
    let color;

    if ($textColor === 'LIGHT') {
      color = convertColorToThemeHexCode('white');
    }

    if ($textColor === 'DARK') {
      color = convertColorToThemeHexCode('black');
    }

    if ($textColor === 'AUTO') {
      color = readableColor($backgroundColor);
    }

    if ($hasImages) {
      return css`
        color: ${color};
        width: 100%;
        z-index: 100;
      `;
    }

    if ($backgroundColor) {
      return css`
        color: ${color};
      `;
    }

    return `color: ${color}`;
  }}
  ${({ $textAlignment }) => {
    if ($textAlignment === 'CENTER') return 'text-align: center;';
  }};
`;

export const CTABlock = styled(CTABlockOriginal)`
  grid-column: 1 / -1;
  margin-right: 0;
  margin-top: 16px;

  ${({ $verticalAlignment }) =>
    $verticalAlignment === 'CENTER'
      ? css`
          align-self: flex-start;
          ${breakpoint('large')} {
            align-self: unset;
          }
        `
      : ''}
`;

export const RichText = styled.div`
  ${({ $layout }) => {
    let fontSize = 24;
    let marginTop = '24px';

    if ($layout === 'COMPRESSED') {
      fontSize = 16;
      marginTop = '16px';
    }

    return css`
      & + ${CTABlock} {
        margin-top: ${marginTop};
      }

      & p {
        ${fontBody(fontSize)}
        ${({ $hasImages }) =>
          $hasImages && 'text-shadow: 4px 4px 8px rgba(17, 0, 0, 0.08);'}
      }

      & a {
        color: inherit;
        ${fontBody(fontSize)}
      }

      & b {
        font-weight: 700;
      }

      & i {
        font-style: italic;
      }
    `;
  }}
`;

export const Title = styled.h1`
  ${({ $hasImages }) =>
    $hasImages && 'text-shadow: 4px 4px 8px rgba(17, 0, 0, 0.08);'}

  ${({ $layout }) => {
    if ($layout === 'COMPRESSED') {
      return `${fontTitle(32)}`;
    }

    return css`
      ${fontTitle(40)}

      ${breakpoint('medium')} {
        ${fontTitle(64)}
      }
    `;
  }}
`;

export const HeaderBlockWrapper = styled.div`
  position: relative;
`;
